/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('.eheights').matchHeight();  

       
          $("#myAffix").affix({
            offset: {
              top: 485,  
              bottom: function() {
                return (this.bottom = $('.footer').outerHeight(true));
              }
            }
          });
      

        $.fn.mathSpace = function() {
          return $(this).each(function(){
            $(this).children('span').each(function() {
              var el = $(this);
              var text = el.text();
              el.text(
                text.split(' ').join('\u205f')
              ); 
            });
          });
        };
        
        $('.title').mathSpace();

        window.onscroll = function() {
          myFunction(); 
        };
        // Get the navbar
        var navbar = $('.nav-bg');
        var cta = $('.cta-btns');

        // Get the offset position of the navbar
        var sticky = navbar.offsetTop;
        function myFunction() {
          
          if (window.pageYOffset >= 500) {
            cta.addClass('hide');
          } else {
            cta.removeClass('hide'); 
          }

          if (window.pageYOffset >= 480) {
            navbar.addClass("sticky");
          } else {
            navbar.removeClass("sticky");
          }
        }

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
         
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        jQuery('[data-fancybox="gallery"]').fancybox({});
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about': {
      init: function() {
        // JavaScript to be fired on the about us page

      }
    },
    'program': {
      init: function() {
         $('.wcs-filters').matchHeight();
         $('.wcs-timetable').matchHeight();


         $('[data-toggle="collapse"].pm').on('click', function() {
                var $this = $(this),
                        $parent = typeof $this.data('parent')!== 'undefined' ? $($this.data('parent')) : undefined;
                if($parent === undefined) { /* Just toggle my  */
                    $this.find('.zmdi').toggleClass('zmdi-plus-circle-o zmdi-minus-circle-outline');
                    return true;
                }
 
                /* Open element will be close if parent !== undefined */
                var currentIcon = $this.find('.zmdi');
                currentIcon.toggleClass('zmdi-plus-circle-o glyphicon-minus');
                $parent.find('.zmdi').not(currentIcon).removeClass('zmdi-minus-circle-outline').addClass('zmdi-plus-circle-o');

            });
      }
    } 
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
